import logo from "./logo.svg";
import "./App.css";
import Navbar from "./Components/Navbar";
import Banner from "./Components/Banner";
import Movies from "./Components/Movies";
import Favourite from "./Components/Favourite";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Bm from "./Components/Bm";

function App() {
  return (<>
    <Router>
      <Navbar />
        {/* <Banner />
        <Movies />
        <Favourite /> */}
      <Routes>
      <Route exact path="/"element={<Bm />}/>
      {/* <Route  path="/" exact render={(props)=>(
        <>
        <Banner {...props}/>
        <Movies {...props}/>
        </>
      )} /> */}
        <Route exact path="/favourites" element={<Favourite/>} />
        
        
      </Routes>
    </Router>
    </>  );
}

export default App;
